import React from 'react';
import { Link } from 'react-router-dom';
import { CFA_INFO } from '../../data/constants';
interface LogoProps {
  className?: string;
  showTagline?: boolean;
  /** Use on dark backgrounds: wraps the logo in a white pill so the dark logo text stays legible. */
  light?: boolean;
}
const LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/5yj4DC2JZN4p4QkgPyD9st/Capture_d’ecran_2026-06-21_a_16.38.47.png';
export function Logo({
  className = '',
  light = false
}: LogoProps) {
  return <Link to="/" aria-label={`${CFA_INFO.name} — accueil`} className={`inline-flex items-center group ${className}`} data-id="element-545" data-mp="dwlfd405bw30">
      {light ? <span className="inline-flex bg-white rounded-2xl px-5 py-4 shadow-sm" data-id="element-546" data-mp="8ximsj1cribx">
          <img src={LOGO_SRC} alt={`${CFA_INFO.name} logo`} className="h-20 w-auto object-contain" data-id="element-547" data-mp="4wynb8tb42mm" />
        </span> : <img src={LOGO_SRC} alt={`${CFA_INFO.name} logo`} className="h-16 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-548" data-mp="1z94xq5edmfdv" />}
    </Link>;
}